export default __webpack_public_path__ + "static/media/search_results.79d62b91.svg";